import { authServiceApi } from "../../app/authServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { AUTH_LOCALSTORAGE_NAME } from "../../constants/constants";
import { toast } from "../../lib/toast";
import {
  ForgotPasswordDataType,
  GetLocationResponseType,
  PatchQueryArgsType,
  SigninDataType,
  SigninResponsiveType,
  SignupDataType,
  SignupResponseType,
} from "../../types";
import { userLoggedIn } from "./authSlice";

export const authApi = authServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    signin: builder.mutation<SigninResponsiveType, SigninDataType>({
      query: (data) => ({
        url: API_URL.signin,
        method: "POST",
        body: data,
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;

          if (data?.data?.userData?.type !== "Admin") {
            return toast(
              "error",
              "You are not allowed to log in. Please try logging in using your mobile app"
            );
          }

          const userData = {
            access_token: data?.data?.token,
            user: data,
            role: data?.data?.userData?.type,
          };

          localStorage.setItem(
            AUTH_LOCALSTORAGE_NAME,
            JSON.stringify(userData)
          );

          localStorage.removeItem("project_role");
          localStorage.removeItem("product_id");
          localStorage.removeItem("product_logo");
          localStorage.removeItem("product_name");

          dispatch(userLoggedIn(userData));
        } catch (err) {}
      },
    }),
    signup: builder.mutation<SignupResponseType, SignupDataType>({
      query: (data) => ({
        url: API_URL.signup,
        method: "POST",
        body: data,
      }),
    }),
    forgotPassword: builder.mutation<unknown, ForgotPasswordDataType>({
      query: (data) => ({
        url: API_URL.forgotPassword,
        method: "PATCH",
        body: data,
      }),
    }),
    resetPassword: builder.mutation({
      query: (data) => ({
        url: API_URL.resetPassword,
        method: "PATCH",
        body: data,
      }),
    }),
    getLocation: builder.query<GetLocationResponseType, unknown>({
      query: () => API_URL.getLocation,
    }),
    updateCompleteProfile: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateCompleteProfile}/${id}`,
        method: "PATCH",
        body,
      }),
    }),
  }),
});

export const {
  useSigninMutation,
  useSignupMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useGetLocationQuery,
  useUpdateCompleteProfileMutation,
} = authApi;
